var React = require('react');

function En (props) {
    return React.createElement("svg",props,[React.createElement("clipPath",{"id":"s","key":0},React.createElement("path",{"d":"M0,0 v30 h60 v-30 z"})),React.createElement("clipPath",{"id":"t","key":1},React.createElement("path",{"d":"M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z"})),React.createElement("g",{"clipPath":"url(#s)","key":2},[React.createElement("path",{"d":"M0,0 v30 h60 v-30 z","fill":"#012169","key":0}),React.createElement("path",{"d":"M0,0 L60,30 M60,0 L0,30","stroke":"#fff","strokeWidth":"6","key":1}),React.createElement("path",{"d":"M0,0 L60,30 M60,0 L0,30","clipPath":"url(#t)","stroke":"#C8102E","strokeWidth":"4","key":2}),React.createElement("path",{"d":"M30,0 v30 M0,15 h60","stroke":"#fff","strokeWidth":"10","key":3}),React.createElement("path",{"d":"M30,0 v30 M0,15 h60","stroke":"#C8102E","strokeWidth":"6","key":4})])]);
}

En.defaultProps = {"viewBox":"0 0 60 30","width":"1200","height":"600"};

module.exports = En;

En.default = En;
